import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import { MaterialHero } from "../../components/static-page-components/material-hero";
import EastIcon from "@mui/icons-material/East";
import { HashLink } from "react-router-hash-link";
import exceptionalClientsImage from "../../assets/our-homeowners-page/Every-Client-Exceptional_m.jpg";
import "../homeowner-page/styles.scss";
import { StageItem } from "../homeowner-page/stage-item";
import { Link } from "react-router";
import { Pages } from "../../utils";
import infoGraphic from "../../assets/our-homeowners-page/demographics and psychographics_d.jpg";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import MapsHomeWorkOutlinedIcon from "@mui/icons-material/MapsHomeWorkOutlined";
import MultipleStopOutlinedIcon from "@mui/icons-material/MultipleStopOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import { StatItem } from "../homeowner-page/stat-item";
import { PersonaCards } from "../homeowner-page/persona-cards";
import { TheVettingProcess } from "../../components/the-vetting-process";
import { HomeownerUserHero } from "../../components/homeowner-user-landing-page/homeowner-user-hero";
import { SplitScreenBlock } from "../../components/static-page-components/split-screen-block";
import magnifyImage from "../../assets/design-community/magnify.jpg";
import CheckIcon from "@mui/icons-material/Check";
import { WhyHDGSection } from "../../components/homeowner-user-landing-page/why-hdg-section";
import { PrettySpacesSection } from "../../components/homeowner-user-landing-page/pretty-spaces-section";
import { Accordion } from "../../components/accordion";
import { OurDesignersSection } from "../../components/homeowner-user-landing-page/our-designers-section";
import { BlogModuleSection } from "../../components/homeowner-user-landing-page/blog-module-section";
import { VideoSection } from "../../components/homeowner-user-landing-page/video-section";
import { TestimonialSection } from "../../components/homeowner-user-landing-page/testimonial-section";
export const HomeownerUserLandingPage = () => {
  return (
    <div className="page homeowner-page">
      <div id="why-join" />
      <HomeownerUserHero />
      <WhyHDGSection />
      <OurDesignersSection />
      <PrettySpacesSection />
      <BlogModuleSection />
      <Box sx={{ height: { xs: 0, md: "108px" }}} />
      <VideoSection />
      <Box sx={{ height: { xs: 0, md: "108px" }}} />
      <TestimonialSection />
      <LandingPageSection>
        <Accordion
          items={[
            {
              title: "How many designers will I be able to match with?",
              description:
                "We curate a selection of designers for you that match at an 80% or higher compatibility rate based on your project, personal preferences and personality. You also have the ability to continue to load more designers into your matching dashboard at any time with visibility to your match % rate.",
            },
            {
              title:
                "What requirements do your designers need to have to be members?",
              description:
                "Homeowners can trust the integrity and professionalism of every designer, knowing they've been vetted and endorsed by the Home Design Guild Seal. We require a minimum of three years of full time working experience, a well-rounded portfolio of work and professional references. Each designer member goes through our application process and a one-on-one interview with a member of our team.",
            },
            {
              title:
                "Why do you charge a fee for your service when others connect me with a pro for free?",
              description:
                "We elevate the experience of finding an interior design partner by creating a seamless process for finding someone who aligns specifically to your needs. We also provide you with the resources to guide you through the process, empowering you with the knowledge to make informed decisions.",
            },
            {
              title:
                "Can I connect with the designers here outside of Home Design Guild?",
              description:
                "Once you have selected a designer as an official match, contact information is shared to both parties. Whether using our matchmaking service or not, we'd encourage you to look for a designer that bears the Home Design Guild Seal. Any designer who has this has been verified and vetted to meet our standards.",
            },
            {
              title:
                "Why should I use Home Design Guild to find a designer vs using the designer my friend used?",
              description:
                "We approach every match as unique and highly personal. When you use Home Design Guild you are matching with a designer that is uniquely aligned to you and your goals. When you use a friend's recommendation, you are getting a designer that was great for their project - which does not always translate to being a great fit for you.",
            },
            {
              title: "Will this save me time in my designer search?",
              description:
                "Once you have your membership in hand, you can be matched in as little time as an hour vs spending endless hours and days doom scrolling through online portfolios and google searches on your own.",
            },
            {
              title:
                "How do I contact the designers I like once I'm matched?",
              description:
                "Once you match you have the ability to view each designer's bio and portfolio as well as directly message and chat back and forth. You can also share the project inspirations you've gathered in your idea book.",
            },
          ]}
        />
      </LandingPageSection>

      <LandingPageSection className="footer-section pink-section text-center">
        <Typography
          variant="h4"
          className="text-center font-body title"
          sx={{ mb: "20px" }}
        >
          {" "}
          Find Your Match.
        </Typography>
        <Typography
          variant="body1"
          className="text-center contain-text text-white  font-size-4"
          sx={{
            mb: "52px",
          }}
        >
          We're the only application that makes the process of finding a designer better by putting the relationship first. Because when you find your perfect match, it all comes together seamlessly.
        </Typography>

        <Button
          component={Link}
          variant="contained"
          size="large"
          to={Pages.SIGNUP}
          color={"white" as any}
          className="font-size-4"
        >
          Sign Up Today
        </Button>
      </LandingPageSection>
    </div>
  );
}; 
